module.exports = __webpack_public_path__ + "media/images/cultural-bp-graph-6a9c6b20478de0bfc1fd6fc9e35b017c.jpg";